import React from "react";
import { UseFormRegisterReturn, FieldError } from "react-hook-form";
import { Tooltip } from "react-tooltip";

interface FormFieldProps {
  label: string;
  type?: string;
  placeholder?: string;
  maxLength?: number;
  showCounter?: boolean;
  error?: FieldError;
  value?: string;
  className?: string;
  register?: UseFormRegisterReturn;
  tooltip?: string;
}

export function FormField({
  label,
  type = "text",
  placeholder,
  maxLength,
  showCounter = false,
  error,
  value = "",
  className = "",
  register,
  tooltip,
}: FormFieldProps) {
  const fieldId = register?.name ? `field-${register.name}` : `field-${label.replace(/\s+/g, "-")}`;
  const errorId = `${fieldId}-error`;
  const tooltipId = `tooltip-${label.replace(/\s+/g, "-")}`;

  const describedBy = [
    error ? errorId : null,
  ].filter(Boolean).join(" ") || undefined;

  return (
    <div className={className}>
      <label htmlFor={fieldId} className="flex items-center gap-1.5 text-gray-bb-1 font-medium mb-1.5 sm:mb-2 text-sm sm:text-base">
        {label}
        {tooltip && (
          <>
            <span
              data-tooltip-id={tooltipId}
              className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-blue-bb text-white-bb text-xs font-bold cursor-help shrink-0"
              aria-label="Ajuda"
            >
              ?
            </span>
            <Tooltip
              id={tooltipId}
              place="top"
              className="!max-w-xs !whitespace-pre-line !z-50"
            >
              {tooltip}
            </Tooltip>
          </>
        )}
      </label>
      <input
        {...register}
        id={fieldId}
        type={type}
        maxLength={maxLength}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        className={`w-full border rounded-lg p-2.5 sm:p-3 text-sm sm:text-base focus:ring-2 focus:ring-blue-bb focus:border-transparent transition-all ${
          error ? "border-red-500" : "border-gray-bb-4"
        }`}
        placeholder={placeholder}
      />
      {showCounter && maxLength && (
        <div className="text-right text-xs sm:text-sm text-gray-bb-2 mt-1" aria-live="polite">
          Caracteres: {value?.length || 0}/{maxLength}
        </div>
      )}
      {error && (
        <p id={errorId} role="alert" className="text-red-500 text-xs sm:text-sm mt-1">{error.message}</p>
      )}
    </div>
  );
}
